/**
 * Attach active org member to file upload input for DealSauce bucket routing.
 */
export function withUploadMember(fileInput, session) {
  const member = session?.me?.activeOrg?.member || ''
  if (!member) return fileInput
  return { ...fileInput, member }
}
